import React, { useEffect, useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff, LocalShipping } from '@mui/icons-material';
import { authAPI } from '../services/api';
import { fetchCompanyInfo } from '../services/companyInfo';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState({});
  useEffect(() => { fetchCompanyInfo().then(setCompany).catch(() => {}); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('아이디와 비밀번호를 입력하세요.');
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.login({ username, password });
      
      if (response.data.success) {
        // 토큰과 사용자 정보 함께 전달
        onLogin(response.data.token, response.data.user);
      }
    } catch (err) {
      setError(err.response?.data?.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
      }}
    >
      <Container maxWidth="xs">
        <Paper elevation={6} sx={{ p: 4, borderRadius: 2 }}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                bgcolor: '#1976d2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              <LocalShipping sx={{ color: 'white', fontSize: 32 }} />
            </Box>
            <Typography variant="h5" fontWeight={700} color="primary">
              {company.company_name || ''} 직원 배차 시스템
            </Typography>
            <Typography variant="body2" color="textSecondary">
              직원/관리자 전용 — 포트 4000
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              label="아이디"
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{ mb: 2 }}
              autoFocus
            />
            <TextField
              label="비밀번호"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 3 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              disabled={loading}
              sx={{ py: 1.5, fontWeight: 600, fontSize: '1rem' }}
            >
              {loading ? '로그인 중...' : '로그인'}
            </Button>
          </form>
        </Paper>

        {/* 사업자 정보 */}
        <Box sx={{ mt: 3, textAlign: 'center', color: 'rgba(255,255,255,0.85)', fontSize: 12 }}>
          <Typography variant="caption" display="block" sx={{ color: 'inherit', mb: 0.3 }}>
            상호: {company.company_name || ''}
            {company.ceo_name ? ` | 대표: ${company.ceo_name}` : ''}
            {company.business_number ? ` | 사업자번호: ${company.business_number}` : ''}
          </Typography>
          {company.company_address && (
            <Typography variant="caption" display="block" sx={{ color: 'inherit', mb: 0.3 }}>
              주소: {company.company_address}
            </Typography>
          )}
          {company.company_phone && (
            <Typography variant="caption" display="block" sx={{ color: 'inherit' }}>
              고객센터: {company.company_phone}
            </Typography>
          )}
        </Box>
      </Container>
    </Box>
  );
}

export default Login;
